function getHeaders(rows, clone = false) {
  return Array.from(rows).reduce((acc, row) => {
    const { rowName: name } = row.dataset;

    acc[name] = {
      name,
      cell: clone ? row.cells[0].cloneNode(true) : row.cells[0],
    };

    return acc;
  }, {});
}

export default getHeaders;
